import { useEffect } from 'react'
import * as Sentry from '@sentry/react'

export const useBugReport = () => {
  useEffect(() => {
    const glitchReport = async (e: KeyboardEvent) => {
      if (e.key === 'g' && (e.metaKey || e.ctrlKey)) {
        const feedback = Sentry.feedbackIntegration({
          enableScreenshot: true,
          autoInject: false,
          colorScheme: 'dark',
          themeDark: {
            background: '#020c1c'
          },
          themeLight: {
            background: '#020c1c'
          },
          showBranding: false
        })
        const form = await feedback.createForm()
        form.appendToDom()
        form.open()
      }
    }

    document.addEventListener('keydown', glitchReport)
    return () => document.removeEventListener('keydown', glitchReport)
  }, [])
}
